module.exports = __webpack_public_path__ + "public/img/09.eaef3082.jpg";